/***************************************************************************/
"use client";
/***************************************************************************/

import { Loader, LucideProps } from "lucide-react";
import * as React from "react";
import { cn } from "../../utils/css";

const LoadingIcon: React.FC<LucideProps> = ({ className, ...props }) => {
  return <Loader className={cn("animate-spin", className)} {...props} />;
};

export default LoadingIcon;
